var Utils = require('../lib/utils');
var Audio = require('../lib/audio');

var createSprite = require('../lib/createSprite');

var audios = {
    pullCrank: new Audio('/audio/28nov/toobig-slot-arm-01.mp3', { channel: 'frame' }),
    releaseCrank: new Audio('/audio/28nov/toobig-manivelle-01.mp3', { channel: 'frame' }),
    spin: new Audio('/audio/28nov/toobig-slot-spin-01.mp3', { channel: 'frame' }),
    win: new Audio('/audio/28nov/toobig-slot-win-01.mp3', { channel: 'frame' }),
    lose: new Audio('/audio/28nov/toobig-slot-loose01.mp3', { channel: 'frame' })
};

var winningProbabilities = {
    '1': 4/5,
    '2': 4/7,
    '3': 0
};

var winningProbability = winningProbabilities['1'];
var displayResultsTimelineTimeScale = 1;

module.exports = {

    getAudios: function() {
        return audios;
    },

    createCharlesSlotMachine: function(opts)
    {
        opts = _.extend({
            width: 0,
            height: 0,
            objs: {},
            size: 'small',
            color: 0xFFFFFF,
            flipResults: false,
            plateauOffset: 0
        }, opts);

        var scale = {
            x: opts.size === 'big' ? '80%':'50%'
        };
        var position = {
            x: opts.size === 'big' ? '10%':'44%',
            y: opts.size === 'big' ? '12%':'21%'
        };
        var withPlateau = opts.size !== 'big';

        var objs = opts.objs;

        var container = new PIXI.Container();

        var plateau;
        if (withPlateau) {
            plateau = createSprite(objs.plateau);
        }
        var machineUnder = createSprite(objs.machineUnder);
        var machineOver = createSprite(objs.machineOver);
        var charles = createSprite(objs.charles);

        // return container;

        charles.userData = { character: true };
        var machineMoneyContainer = new PIXI.Sprite();

        var machineResultsContainer = new PIXI.Sprite();
        var machineResultsMaskContainer = new PIXI.Sprite();

        // loop
        var singleResultWin1 = createSprite(objs.singleResultWin);
        var singleResultWin2 = createSprite(objs.singleResultWin);
        var singleResultWin3 = createSprite(objs.singleResultWin);
        var singleResultLose1 = createSprite(objs.singleResultLose);
        var singleResultLose2 = createSprite(objs.singleResultLose);
        var singleResultLose3 = createSprite(objs.singleResultLose);
        singleResultWin1.name = 'singleResultWin1';
        singleResultWin2.name = 'singleResultWin2';
        singleResultWin3.name = 'singleResultWin3';
        singleResultLose1.name = 'singleResultLose1';
        singleResultLose2.name = 'singleResultLose2';
        singleResultLose3.name = 'singleResultLose3';

        Utils.setSizeAndPositionFromRefSize([machineUnder, machineOver], opts.width, opts.height, {
            position: position,
            scale: scale
        });
        Utils.setSizeAndPositionFromRefSprite([singleResultWin1, singleResultLose1], machineUnder, _.merge({
            position: {
                x: '11.8%',
                y: '9.5%'
            },
            scale: {
                x: '9.5%'
            }
        },objs.singleResultWin));
        Utils.setSizeAndPositionFromRefSprite([singleResultWin2, singleResultLose2], machineUnder, _.merge({
            position: {
                x: '32%',
                y: '10%'
            },
            scale: {
                x: '11%'
            }
        },objs.singleResultWin));
        Utils.setSizeAndPositionFromRefSprite([singleResultWin3, singleResultLose3], machineUnder, _.merge({
            position: {
                x: '56%',
                y: '11%'
            },
            scale: {
                x: '11%'
            }
        },objs.singleResultWin));

        if (opts.flipResults)
        {
            singleResultWin1.scale.x *= -1;
            singleResultWin2.scale.x *= -1;
            singleResultWin3.scale.x *= -1;
            singleResultLose1.scale.x *= -1;
            singleResultLose2.scale.x *= -1;
            singleResultLose3.scale.x *= -1;
            singleResultWin1.rotation =
            singleResultWin2.rotation =
            singleResultWin3.rotation = 20 * Math.PI / 180;
            singleResultLose1.rotation =
            singleResultLose2.rotation =
            singleResultLose3.rotation = 10 * Math.PI / 180;
            var deltaXwin = opts.width * 0.08;
            var deltaXlose = opts.width * 0.06;
            var deltaYwin = opts.height * 0.01;
            var deltaYlose = opts.height * 0.008;
            singleResultWin1.x += deltaXwin;
            singleResultWin2.x += deltaXwin;
            singleResultWin3.x += deltaXwin;
            singleResultLose1.x += deltaXlose;
            singleResultLose2.x += deltaXlose;
            singleResultLose3.x += deltaXlose;
            singleResultWin1.y += deltaYwin;
            singleResultWin2.y += deltaYwin;
            singleResultWin3.y += deltaYwin;
            singleResultLose1.y += deltaYlose;
            singleResultLose2.y += deltaYlose;
            singleResultLose3.y += deltaYlose;
        }

        var machineResultsMask = new PIXI.Graphics();
        machineResultsMask.beginFill(0xFFFFFF);
        machineResultsMask.moveTo(0, machineOver.height * 0.07);
        machineResultsMask.lineTo(machineOver.width * 0.8, machineOver.height * 0.09);
        machineResultsMask.lineTo(machineOver.width * 0.74, machineOver.height * 0.324);
        machineResultsMask.lineTo(0, machineOver.height * 0.28);
        machineResultsMask.endFill();
        machineResultsMask.x = machineOver.x;
        machineResultsMask.y = machineOver.y;
        machineResultsMask.cacheAsBitmap = true;
        machineResultsMaskContainer.mask = machineResultsMask;

        var machineMoneyMask = new PIXI.Graphics();
        machineMoneyMask.beginFill(0x000000);
        machineMoneyMask.moveTo(machineUnder.width * 0.106, machineUnder.height * 0.015);
        machineMoneyMask.lineTo(machineUnder.width * 0.83, machineUnder.height * 0.005);
        machineMoneyMask.lineTo(machineUnder.width * 0.991, machineUnder.height * 0.009);
        machineMoneyMask.lineTo(machineUnder.width * 0.9909, machineUnder.height * 0.9314);
        machineMoneyMask.lineTo(machineUnder.width * 0.7, machineUnder.height);
        machineMoneyMask.lineTo(machineUnder.width * 0.03, machineUnder.height * 0.841);
        machineMoneyMask.lineTo(machineUnder.width * 0.03, machineUnder.height * 0.398);
        machineMoneyMask.lineTo(machineUnder.width * 0.008, machineUnder.height * 0.388);
        machineMoneyMask.lineTo(machineUnder.width * 0.005, machineUnder.height * 0.3315);
        machineMoneyMask.lineTo(machineUnder.width * 0.04, machineUnder.height * 0.3014);
        machineMoneyMask.lineTo(machineUnder.width * 0.1, machineUnder.height * 0.19);
        machineMoneyMask.endFill();
        machineMoneyMask.x = machineUnder.x;
        machineMoneyMask.y = machineUnder.y;

        machineResultsContainer.addChild(singleResultWin1);
        machineResultsContainer.addChild(singleResultWin2);
        machineResultsContainer.addChild(singleResultWin3);
        machineResultsContainer.addChild(singleResultLose1);
        machineResultsContainer.addChild(singleResultLose2);
        machineResultsContainer.addChild(singleResultLose3);

        var machineMoney = this.createMachineMoney(machineMoneyMask, opts.color);

        machineMoneyContainer.y -= machineOver.height / 2;

        charles.name = 'charles';
        machineMoney.name = 'machineMoney';
        machineMoneyContainer.name = 'machineMoneyContainer';
        machineResultsMaskContainer.name = 'machineResultsMaskContainer';
        machineResultsContainer.name = 'machineResultsContainer';
        machineResultsMask.name = 'machineResultsMask';

        var charlesResultsRatio = Utils.getValueInPixels(scale.x) * 1.25;
        var charlesResultsDiffRatio = (1 - charlesResultsRatio);

        Utils.setSizeAndPositionFromRefSize(charles, opts.width, opts.height, {
            scale: {
                x: charlesResultsRatio
            },
            position: {
                x: charlesResultsDiffRatio / 2,
                y: position.y
            }
        });

        if (withPlateau) {
            var plateauRatio = Utils.getValueInPixels(scale.x) * 2;
            Utils.setSizeAndPositionFromRefSize(plateau, opts.width, opts.height, {
                scale: {
                    x: plateauRatio
                },
                position: {
                    x: objs.plateau.position.x,
                    y: objs.plateau.position.y
                }
            });
            plateau.x += (opts.plateauOffset * opts.width);
            container.addChild(plateau);
        }

        TweenMax.set(charles, {
            x: '+='+ charlesResultsDiffRatio * machineUnder.width
        });

        container.addChild(machineUnder);
        container.addChild(machineMoneyContainer);
        machineMoneyContainer.addChild(machineMoney);
        container.addChild(machineMoneyMask);
        container.addChild(machineOver);
        container.addChild(machineResultsMask);
        container.addChild(machineResultsMaskContainer);
        machineResultsMaskContainer.addChild(machineResultsContainer);
        container.addChild(charles);

        return container;
    },

    createMachineMoney: function(mask, color)
    {
        var money = new PIXI.Graphics();
        money.beginFill(color);
        money.drawRect(0,0, mask.width, mask.height * 2);
        money.endFill();
        money.x = mask.x;
        money.y = mask.y + mask.height;
        money.mask = mask;

        return money;
    },

    getCharlesSlotMachineTimeline: function(container, opts)
    {
        opts = _.extend({
            pullCrankDuration: 0.6,
            releaseCrankDuration: 0.4,
            spinningRepeat: 6,
            spinDuration: 0.4,
            lastSpinDuration: 0.3,
            spinStagger: 0.08,
            spinMovementX: 0.3,
            spinMovementY: 1.75,
            winningHeightPercent: '5%',
            losingHeightPercent: '4%',
            charlesReactionDuration: 0.8,
            displayResultsDuration: 2,
            moneyAdjustDuration: 0.8,
            moneyFloatingDuration: 1,
            moneyFloatingHeightPercent: '1%',
            flipResults: true,
            playSounds: true
        }, opts);

        var charles = container.getChildByName('charles');

        var machineMoneyContainer = container.getChildByName('machineMoneyContainer');
        var machineMoney = machineMoneyContainer.getChildByName('machineMoney');
        var machineResultsMaskContainer = container.getChildByName('machineResultsMaskContainer');
        var machineResultsContainer = machineResultsMaskContainer.getChildByName('machineResultsContainer');
        var machineResultsMask = container.getChildByName('machineResultsMask');

        var singleResultWin1 = machineResultsContainer.getChildByName('singleResultWin1');
        var singleResultWin2 = machineResultsContainer.getChildByName('singleResultWin2');
        var singleResultWin3 = machineResultsContainer.getChildByName('singleResultWin3');

        var singleResultLose1 = machineResultsContainer.getChildByName('singleResultLose1');
        var singleResultLose2 = machineResultsContainer.getChildByName('singleResultLose2');
        var singleResultLose3 = machineResultsContainer.getChildByName('singleResultLose3');

        if (opts.flipResults)
        {
            singleResultWin1 = singleResultWin3;
            singleResultWin3 = machineResultsContainer.getChildByName('singleResultWin1');
            singleResultLose1 = singleResultLose3;
            singleResultLose3 = machineResultsContainer.getChildByName('singleResultLose1');
        }

        var blurFilter = new PIXI.filters.BlurFilter();// strength=8, quality=4, resolution=1
        blurFilter.blurX = 4;
        blurFilter.blurY = 50;

        machineResultsContainer.alpha = 0;

        var win;
        var fromCharlesFrame;
        var toCharlesFrame;
        var fromMoneyY;
        var toMoneyY;

        // crank: 0-5
        var charlesParams = {
            frame: 0
        };

        var mainTimeline = new TimelineMax();

        var loopTimeline = new TimelineMax({
            repeat: -1,
        });

        var charlesCrankTimeline = new TimelineMax({
            onUpdateParams: [charles, charlesParams],
            onUpdate: Utils.updateMovieclipParams
        });

        // pull crank
        charlesCrankTimeline.to(charlesParams, opts.pullCrankDuration, {
            onStart: function(){
                if (opts.playSounds)
                {
                    TweenMax.delayedCall(0.2, function(){
                        audios.pullCrank.play();
                    });
                    TweenMax.delayedCall(opts.pullCrankDuration-0.2, function(){
                        audios.releaseCrank.play();
                    });
                }
            },
            frame: 5,
            ease: Linear.easeNone
        });
        // release crank
        charlesCrankTimeline.to(charlesParams, opts.releaseCrankDuration, {
            frame: 6,
            ease: Linear.easeNone
        });
        loopTimeline.add(charlesCrankTimeline);
        var spinningTimeline = new TimelineMax({
            onStart: function(){
                if (opts.playSounds)
                {
                    audios.spin.play();
                }
                machineResultsContainer.filters = [blurFilter];
                win = _.random(0, 1, true) < winningProbability;
                fromCharlesFrame = win ? 7:14;
                toCharlesFrame = win ? 13:23;
                var moneyDeltaY = win ? -machineMoney.height * Utils.getValueInPixels(opts.winningHeightPercent) : machineMoney.height * Utils.getValueInPixels(opts.losingHeightPercent);
                fromMoneyY = machineMoneyContainer.y;
                toMoneyY = Math.max(-machineMoney.height/2 + machineMoney.height * 0.01, Math.min(0, machineMoneyContainer.y + moneyDeltaY));
            }
        });
        var spinningWinTimeline = new TimelineMax()
        .staggerFromTo([singleResultWin1, singleResultWin2, singleResultWin3], opts.spinDuration, {
            x: '+='+singleResultWin2.width * opts.spinMovementX,
            y: '-='+singleResultWin2.height * opts.spinMovementY
        },{
            x: '-='+singleResultWin2.width * opts.spinMovementX * 2,
            y: '+='+singleResultWin2.height * opts.spinMovementY * 2,
            ease: Linear.easeNone,
            repeat: opts.spinningRepeat
        }, opts.spinStagger)
        .staggerFromTo([singleResultWin1, singleResultWin2, singleResultWin3], opts.lastSpinDuration, {
            x: '-=0.01',
            y: '-=0.01',
        },{
            x: '-='+singleResultWin2.width * opts.spinMovementX,
            y: '+='+singleResultWin2.height * opts.spinMovementY,
            ease: Back.easeOut
        }, opts.spinStagger);

        var spinningLoseTimeline = new TimelineMax()
        .staggerFromTo([singleResultLose1, singleResultLose2, singleResultLose3], opts.spinDuration, {
            x: '+='+singleResultLose2.width * opts.spinMovementX,
            y: '-='+singleResultLose2.height * opts.spinMovementY
        },{
            x: '-='+singleResultLose2.width * opts.spinMovementX * 2,
            y: '+='+singleResultLose2.height * opts.spinMovementY * 2,
            ease: Linear.easeNone,
            repeat: opts.spinningRepeat
        }, opts.spinStagger)
        .staggerFromTo([singleResultLose1, singleResultLose2, singleResultLose3], opts.lastSpinDuration, {
            x: '-=0.01',
            y: '-=0.01',
        },{
            x: '-='+singleResultLose2.width * opts.spinMovementX,
            y: '+='+singleResultLose2.height * opts.spinMovementY,
            ease: Back.easeOut
        }, opts.spinStagger);

        spinningTimeline.set({}, {
            onStart: function(){
                singleResultWin1.visible =
                singleResultWin2.visible =
                singleResultWin3.visible =
                singleResultLose1.visible =
                singleResultLose2.visible =
                singleResultLose3.visible = true;
                machineResultsContainer.filters = [blurFilter];
            }
        });
        spinningTimeline.add(spinningWinTimeline);
        spinningTimeline.add(spinningLoseTimeline, opts.spinDuration/2);
        spinningTimeline.set({}, {
            onStart: function(){
                if (opts.playSounds)
                {
                    audios.spin.stop();
                    if (win)
                    {
                        audios.win.play();
                    } else {
                        audios.lose.play();
                    }
                }
                if (!win)
                {
                    singleResultLose1.visible =
                    singleResultLose2.visible =
                    singleResultLose3.visible = false;
                } else {
                    singleResultWin1.visible =
                    singleResultWin2.visible =
                    singleResultWin3.visible = false;
                }
                machineResultsContainer.filters = null;
            }
        }, '-='+(opts.spinDuration + opts.lastSpinDuration));
        spinningTimeline.to(machineResultsContainer, 0.3, {
            alpha: 1
        }, 0);
        loopTimeline.add(spinningTimeline, '-=0.4');
        // display results
        var displayResultsTimeline = new TimelineMax();
        var reactionCount = {
            charles: 0,
            money: 0
        };
        // show charles reaction
        displayResultsTimeline.fromTo(reactionCount, opts.charlesReactionDuration, {
            charles: 0
        },{
            charles: 1,
            ease: Linear.easeNone,
            onUpdate: function(){
                var frame = Math.round(fromCharlesFrame + (toCharlesFrame - fromCharlesFrame) * this.target.charles);
                Utils.updateMovieclipParams(charles, {
                    frame: frame
                });
            }
        }, 0);
        // adjust money position
        displayResultsTimeline.fromTo(reactionCount, opts.moneyAdjustDuration, {
            money: 0
        }, {
            money: 1,
            ease: Quad.easeInOut,
            onUpdate: function()
            {
                var newY = fromMoneyY + (toMoneyY - fromMoneyY) * this.target.money;
                machineMoneyContainer.y = newY;
            }
        }, 0);

        opts.displayResultsDuration = _.isFunction(opts.displayResultsDuration) ? opts.displayResultsDuration():opts.displayResultsDuration;

        loopTimeline.add(displayResultsTimeline, '-=0.4');
        var displayResultsDelayTimeline = new TimelineMax({
            onStart: function(){
                displayResultsDelayTimeline.timeScale(displayResultsTimelineTimeScale);
            }
        });
        displayResultsDelayTimeline.to({}, opts.displayResultsDuration * 0.6, {});
        displayResultsDelayTimeline.to(machineResultsContainer, opts.displayResultsDuration * 0.4, {
            alpha: 0
        });
        loopTimeline.add(displayResultsDelayTimeline);

        var moneyTween = mainTimeline.to(machineMoney, opts.moneyFloatingDuration, {
            y: '-='+machineMoney.height * Utils.getValueInPixels(opts.moneyFloatingHeightPercent),
            yoyo: true,
            repeat: -1,
            ease: Quad.easeInOut
        });

        // mainTimeline.add(loopTimeline, 0);
        return {
            mainTimeline,
            loopTimeline,
        };
    },

    setCharlesSlotMachineIntensityPosition: function(container, intensity)
    {
        return TweenMax.to(container, 2, {
            y: container.height * -0.02 * (intensity-1),
            ease: Quad.easeInOut
        });
    },

    setCharlesSlotMachinesIntensity: function(intensity)
    {
        displayResultsTimelineTimeScale = 1 + (intensity - 1) * 0.75;
        winningProbability = _.get(winningProbabilities, intensity+'');
    }
};



// WEBPACK FOOTER //
// ./js/animations/slotMachine.js